// External tool context actions
export const CLEAR_EXTERNAL_TOOL_CONTEXT = 'CLEAR_EXTERNAL_TOOL_CONTEXT';
export const SET_EXTERNAL_TOOL_CONTEXT = 'SET_EXTERNAL_TOOL_CONTEXT';
export const EXTERNAL_TOOL_UPDATE_SUCCESS = 'EXTERNAL_TOOL_UPDATE_SUCCESS';
export const GET_EXTERNAL_TOOL_CONTEXT = 'GET_EXTERNAL_TOOL_CONTEXT';
